export enum QueryKey {
    AdminTools = 'admin-tools',
    AsyncBulkImportMappings = 'async-bulk-import-mappings',
    AsyncCsvBulkImport = 'async-csv-bulk-import',
    AppInfo = 'app-info',
    ApproveBidders = 'post-approve-bidders',
    AtgAdminUsers = 'atg-admin-users',
    Auction = 'fetch-auction-data',
    AuctionLinkGroup = 'fetch-auction-link-group',
    AuctionLineItems = 'auction-line-items',
    AuctionLots = 'fetch-auction-lots',
    AuctionStaggerInfo = 'fetch-auction-stagger-info',
    AuctionTemplate = 'fetch-auction-template',
    AuctionTemplates = 'fetch-auction-templates',
    AuctionTransformations = 'auction-transformations',
    Auctions = 'fetch-auctions-data',
    BidderList = 'bidder-list',
    BidderNavigator = 'fetch-bidder-navigator',
    BidderProfile = 'fetch-bidder-profile',
    Bidders = 'fetch-bidders',
    BiddersCSV = 'bidders-csv',
    BulkImportCsv = 'bulk-import-csv',
    BulkImportMappedItems = 'bulk-import-mapped-items',
    BulkLotEdit = 'bulk-lot-edit',
    BulkLotRenumber = 'bulk-lot-renumber',
    BulkLotRenumberStatus = 'bulk-lot-renumber-status',
    BulkPhotoBatches = 'bulk-photo-batches',
    BulkPhotoUploadBatch = 'bulk-photo-upload-batch',
    CheckDuplicates = 'check-duplicates',
    CoverLots = 'cover-lots',
    CreateAuction = 'create-new-auction',
    CreateSingleInventory = 'create-single-inventory',
    CustomCategories = 'custom-categories',
    CustomCategoryEntitlement = 'custom-category-entitlement',
    DeclineBidders = 'post-decline-bidders',
    DeleteAttachments = 'delete-attachments',
    DeleteAuction = 'delete-auction',
    DeleteBidderFromList = 'delete-bidder-from-list',
    DeleteBulkLots = 'delete-bulk-lots',
    DeleteHouseUser = 'delete-house-user',
    DeleteLotPhotos = 'delete-lot-photos',
    DownloadBulkLotEditTransformationReport = 'download-bulk-lot-edit-transformation-report',
    DownloadRatingsCSV = 'download-ratings-csv',
    EligibleAuctions = 'fetch-eligible-auctions',
    EnabledDestinationMarketplaces = 'enabled-destination-marketplaces',
    GetLotByLotNumber = 'fetch-lot-by-lot-number',
    House = 'house',
    HouseLineItems = 'house-line-items',
    HouseUsers = 'house-users',
    HouseList = 'house-list',
    InfiniteAuctionLots = 'fetch-infinite-auction-lots',
    InfiniteLots = 'fetch-infinite-lots',
    InvoiceDetail = 'fetch-invoice-detail',
    InvoiceNavigator = 'fetch-invoice-navigator',
    Invoices = 'fetch-invoices',
    LatestBulkLotRenumber = 'latest-bulk-lot-renumber',
    LatestInvoiceGeneration = 'fetch-latest-invoice-generation',
    LinkGroupRegistrationSettings = 'fetch-link-group-registration-settings',
    LinkGroups = 'fetch-link-groups',
    LinkImpact = 'link-impact',
    Login = 'login',
    LotBids = 'lot-bids',
    LotEndtimePreview = 'lotEndtimePreview',
    LotImport = 'lot-import',
    LotLineItems = 'lot-line-items',
    LotNavigator = 'fetch-lot-navigator',
    LotNumberAvailability = 'check-lot-number-availability',
    LotTracker = 'fetch-lot-tracker',
    MergePreview = 'merge-preview',
    MetaOptions = 'fetch-meta-options',
    MoveLotImages = 'move-lot-images',
    ParseCsvBulkImport = 'parse-csv-bulk-import',
    PatchHouseUserActivate = 'patch-house-user-activate',
    PatchHouseUserEnabled = 'patch-house-user-enabled',
    PatchRatingAdminComment = 'patch-rating-admin-comment',
    PatchRatingHide = 'patch-rating-hide',
    PasswordReset = 'password-reset',
    PasswordResetEmail = 'password-reset-email',
    PostBidderToList = 'post-bidder-to-list',
    PostBidRetraction = 'post-bid-retraction',
    PostBulkLotEdit = 'post-bulk-lot-edit',
    PostInvoiceGeneration = 'post-invoice-generation',
    PutInvoiceSave = 'put-invoice-save',
    PutBidderToList = 'put-bidder-to-list',
    Rating = 'rating',
    Ratings = 'ratings',
    RegistrationComment = 'post-registration-comment',
    RegistrationHistory = 'fetch-registration-history',
    ReportBuyer = 'post-report-buyer',
    RotateImage = 'rotate-image',
    ServerRequests = 'server-requests',
    Taxonomy = 'taxonomy',
    UpdateAuction = 'update-auction',
    UpdateCoverLots = 'update-cover-lots',
    UpdateHouseUser = 'update-house-user',
    Winners = 'fetch-winners',
    WinnersCSV = 'winners-csv',
}
